//
import PropTypes from "prop-types"
import genericFilterGroup from "shared/search/containers/FilterGroup/FilterGroups.js"
import {
    RepresentingStateFilter,
    RepresentingCountyFilter,
    GeoshapeTypeFilter,
    GeoshapeTypeForBriefBuilderFilter,
} from "shared/search/containers/Filter/Filters"
import { GeographyPartyFilter } from "shared/search/containers/Filter/GeographyFilters.js"

export const GeographyStateFilterGroup = (props) => genericFilterGroup(props)
GeographyStateFilterGroup.propTypes = {
    filters: PropTypes.array,
    uniqueFilterGroupId: PropTypes.string,
    displayLabel: PropTypes.string,
    helpText: PropTypes.string,
}
GeographyStateFilterGroup.defaultProps = {
    filters: [RepresentingStateFilter],
    uniqueFilterGroupId: "geographyRegionFilterGroup",
    displayLabel: "Region",
    helpText: "Filter by state",
}

export const GeographyStateAndCountyFilterGroup = (props) => genericFilterGroup(props)
GeographyStateAndCountyFilterGroup.propTypes = {
    filters: PropTypes.array,
    uniqueFilterGroupId: PropTypes.string,
    displayLabel: PropTypes.string,
    helpText: PropTypes.string,
}
GeographyStateAndCountyFilterGroup.defaultProps = {
    filters: [RepresentingStateFilter, RepresentingCountyFilter],
    uniqueFilterGroupId: "geographyRegionFilterGroup",
    displayLabel: "Region",
    helpText: "Filter by state and/or county",
}

export const GeographyPartyFilterGroup = (props) => genericFilterGroup(props)
GeographyPartyFilterGroup.propTypes = {
    filters: PropTypes.array,
    uniqueFilterGroupId: PropTypes.string,
    displayLabel: PropTypes.string,
    helpText: PropTypes.string,
}
GeographyPartyFilterGroup.defaultProps = {
    filters: [GeographyPartyFilter],
    uniqueFilterGroupId: "personPartyFilterGroup",
    displayLabel: "Party",
    helpText: "Filter states by senate majority",
}

export const GeoShapeTypeFilterGroup = (props) => genericFilterGroup(props)
GeoShapeTypeFilterGroup.propTypes = {
    filters: PropTypes.array,
    uniqueFilterGroupId: PropTypes.string,
    displayLabel: PropTypes.string,
    helpText: PropTypes.string,
}
GeoShapeTypeFilterGroup.defaultProps = {
    filters: [GeoshapeTypeFilter],
    uniqueFilterGroupId: "geoshapeFilterGroup",
    displayLabel: "Geography Type",
    helpText: "Filter by geography type",
}

export const GeoShapeTypeForBriefBuilderFilterGroup = (props) => genericFilterGroup(props)
GeoShapeTypeForBriefBuilderFilterGroup.propTypes = {
    filters: PropTypes.array,
    uniqueFilterGroupId: PropTypes.string,
    displayLabel: PropTypes.string,
    helpText: PropTypes.string,
}
GeoShapeTypeForBriefBuilderFilterGroup.defaultProps = {
    filters: [GeoshapeTypeForBriefBuilderFilter],
    uniqueFilterGroupId: "geoshapeFilterGroup",
    displayLabel: "Geography Type",
    helpText: "Filter by geography type",
}
